import './PlayerComponents.css';
import { openBlock as a, createElementBlock as n, createCommentVNode as h, createElementVNode as u, toDisplayString as p, Fragment as w, renderList as g, normalizeClass as V, resolveComponent as o, createBlock as d, normalizeStyle as L, defineAsyncComponent as T } from "vue";
import { a as f } from "./platform-components-assets/index-es.js";
import { _ as m } from "./platform-components-assets/_plugin-vue_export-helper-es.js";
import { NebulaButton as U, NebulaImage as j } from "@discoveryedu/nebula-components";
import A from "./imageUrl.js";
const M = {
  name: "ArticleViewer",
  props: {
    asset: {
      type: Object,
      required: !0
    }
  }
}, S = ["innerHTML"];
function R(t, i, e, c, s, r) {
  return e.asset ? (a(), n("div", {
    key: 0,
    class: "asset-player-content__article",
    innerHTML: e.asset.article_html
  }, null, 8, S)) : h("", !0);
}
const q = /* @__PURE__ */ m(M, [["render", R]]), x = {
  name: "PDFViewer",
  props: {
    asset: {
      type: Object,
      required: !0
    },
    docreaderDomain: {
      type: String
    }
  },
  computed: {
    docReaderBaseURL() {
      return `https://${this.docreaderDomain}/docreader/index.php?`;
    },
    formattedSrc() {
      return `${this.docReaderBaseURL}${this.formatUrlParams()}${encodeURIComponent(this.asset.clean_media_files[0].url)}`;
    }
  },
  methods: {
    formatUrlParams() {
      const t = "jsmode=1&cid=brqmy&bp=sptol=0.3&glang=en&url=";
      return this.asset.is_downloadable ? t : `conf=adapted&${t}`;
    }
  }
}, O = { key: 0 }, $ = ["src"];
function B(t, i, e, c, s, r) {
  return e.asset ? (a(), n("div", O, [
    u("iframe", {
      src: r.formattedSrc,
      width: "100%",
      height: "1000",
      frameborder: "0"
    }, null, 8, $)
  ])) : h("", !0);
}
const C = /* @__PURE__ */ m(x, [["render", B]]), E = {
  name: "ReviewSheet",
  components: {},
  props: {
    asset: {
      type: Object,
      required: !0
    }
  }
}, N = {
  key: 0,
  class: "asset-player-content__review-sheet"
}, H = { key: 0 }, F = { key: 1 }, z = { key: 2 }, X = ["innerHTML"], G = ["innerHTML"];
function J(t, i, e, c, s, r) {
  return e.asset ? (a(), n("div", N, [
    e.asset.review_sheet_data.is_techbook_unit ? (a(), n("h3", H, p(t.$t("Unit Review")) + ": " + p(e.asset.title), 1)) : (a(), n("h3", F, p(t.$t("Concept Review")) + ": " + p(e.asset.title), 1)),
    e.asset.review_sheet_data.unit_reviews ? (a(), n("div", z, [
      (a(!0), n(w, null, g(e.asset.review_sheet_data.unit_reviews, (l) => (a(), n("div", {
        key: l.title
      }, [
        u("h4", {
          innerHTML: l.title
        }, null, 8, X),
        u("div", {
          innerHTML: l.description
        }, null, 8, G)
      ]))), 128))
    ])) : h("", !0)
  ])) : h("", !0);
}
const K = /* @__PURE__ */ m(E, [["render", J]]), Q = {
  name: "InteractiveViewer",
  props: {
    asset: {
      type: Object,
      required: !0
    },
    windowPaths: {
      type: Object
    }
  },
  data() {
    return {
      scriptsLoaded: 0
    };
  },
  mounted() {
    const t = document.createElement("link");
    t.setAttribute("href", `${this.windowPaths.core_static}dist/cssmin/player/embedded-interactive.css`), t.setAttribute("rel", "stylesheet"), t.setAttribute("type", "text/css"), t.setAttribute("id", "interactives-styles"), document.head.appendChild(t), [
      `${this.windowPaths.core_static}interactives/mathjax/MathJax.js?config=TeX-AMS-MML_HTMLorMML-full`,
      `${this.windowPaths.core_static}js/interactives/client/client.js`,
      `${this.windowPaths.core_static}interactives/math/common/js/api/interactives-api.js`,
      `${this.windowPaths.core_static}interactives/math/common/js/api/preloader.js`
    ].forEach((e, c) => {
      const s = document.createElement("script");
      s.setAttribute("id", `interactives-script-${c + 1}`), s.setAttribute("src", e), s.addEventListener("load", this.onLoaded), document.head.appendChild(s);
    });
  },
  beforeUnmount() {
    document.getElementById("interactives-styles").disabled = !0, document.querySelectorAll("script[id^=interactives-script-]").forEach((t) => t.remove());
  },
  methods: {
    onLoaded() {
      if (this.scriptsLoaded += 1, this.scriptsLoaded === 4) {
        let t = null;
        const i = this.asset.media_files.find((e) => e.format_id === 43);
        i && (t = i.file_name || null), DEInteractivesClient.init({
          basePath: this.asset.embedded_interactive_data.base_path,
          staticPath: this.windowPaths.edde_static
        }), DEInteractivesClient.loadInteractive({
          bAllowAccessibility: !0,
          callbackData: {
            interactiveGuid: this.asset.id
          },
          // callbacks
          success: function() {
          },
          error: function() {
          },
          complete: function() {
          },
          containerId: `interactive-${this.asset.id}`,
          folderName: t,
          initialState: null,
          initialTabIndex: 1e4,
          interactiveGuid: this.asset.id,
          lang: this.asset.language_code || "eng",
          // 4=english, currently only english is supported
          bookId: 4,
          pageId: this.asset.id
        });
      }
    }
  }
}, W = { class: "dad-asset-content dad-asset-content--interactive" }, Y = { class: "dad-asset-content__inner" }, Z = ["id"];
function ee(t, i, e, c, s, r) {
  return a(), n("div", W, [
    u("div", Y, [
      u("div", {
        id: `interactive-${e.asset.id}`
      }, null, 8, Z)
    ])
  ]);
}
const te = /* @__PURE__ */ m(Q, [["render", ee]]), se = {
  name: "IframeViewer",
  props: {
    asset: {
      type: Object,
      required: !0
    },
    codingUrl: {
      type: String
    }
  },
  data() {
    return {
      codingType: "3a02114e-f812-4840-82de-ec9c68835e5d"
    };
  },
  mounted() {
    if (this.asset.type.id === this.codingType) {
      const t = document.createElement("script");
      t.setAttribute("src", `${this.codingUrl}/app/dist/embed-global-hub.js`), document.head.appendChild(t);
    }
  },
  computed: {
    src() {
      return this.asset.type.id === this.codingType ? !1 : this.asset.iframe_data.html5_url ? this.asset.iframe_data.html5_url : this.asset.iframe_data.html_url;
    },
    width() {
      return this.asset.iframe_data.html5_url ? this.asset.iframe_data.html5_width : this.asset.iframe_data.width;
    },
    height() {
      return this.asset.iframe_data.html5_url ? this.asset.iframe_data.html5_height : this.asset.iframe_data.height;
    },
    padding() {
      return this.asset.iframe_data.html5_url ? this.asset.iframe_data.html5_padding : this.asset.iframe_data.padding;
    }
  }
}, ae = { class: "embedded-player__container--iframe" }, ie = ["title", "src", "width", "height"], ne = ["title", "data-src", "src", "width", "height", "padding"];
function re(t, i, e, c, s, r) {
  return a(), n("div", ae, [
    e.asset.iframe_data.embed ? (a(), n("embed", {
      key: 0,
      title: e.asset.title,
      src: e.asset.iframe_data.html_url,
      width: e.asset.iframe_data.width,
      height: e.asset.iframe_data.height
    }, null, 8, ie)) : (a(), n("iframe", {
      key: 1,
      title: e.asset.title,
      allowfullscreen: "true",
      frameborder: "0",
      class: V(e.asset.type.id === s.codingType && "de-coding-app"),
      "data-src": e.asset.type.id === s.codingType && e.asset.iframe_data.html5_url,
      src: r.src,
      width: r.width,
      height: r.height,
      padding: r.padding,
      referrerpolicy: "strict-origin-when-cross-origin"
    }, null, 10, ne))
  ]);
}
const oe = /* @__PURE__ */ m(se, [["render", re]]), de = {
  name: "OtherViewer",
  components: {
    NebulaButton: U
  },
  props: {
    asset: {
      type: Object,
      required: !0
    }
  }
}, ce = {
  key: 0,
  class: "asset-player-content__other"
};
function le(t, i, e, c, s, r) {
  const l = o("NebulaButton");
  return e.asset ? (a(), n("div", ce, [
    (a(!0), n(w, null, g(e.asset.clean_media_files, (_) => (a(), d(l, {
      key: _.id,
      link: _.url,
      size: "m",
      "icon-left": "download",
      text: t.$t("Download")
    }, null, 8, ["link", "text"]))), 128))
  ])) : h("", !0);
}
const me = /* @__PURE__ */ m(de, [["render", le]]), he = {
  name: "ImageDetail",
  components: {
    NebulaImage: j
  },
  mixins: [A],
  props: {
    asset: {
      type: Object,
      required: !0
    },
    isInline: {
      type: Boolean
    }
  },
  emits: ["img-loaded"],
  computed: {
    cssProps() {
      return this.isInline ? "--nebula-image-aspect-ratio: 16/9" : "";
    }
  }
};
function ue(t, i, e, c, s, r) {
  const l = o("NebulaImage");
  return a(), d(l, {
    alt: e.asset.description,
    contained: !0,
    src: t.imageUrl,
    style: L(r.cssProps),
    class: "image-detail"
  }, null, 8, ["alt", "src", "style"]);
}
const _e = /* @__PURE__ */ m(he, [["render", ue]]), pe = T(
  () => import(
    /* webpackChunkName: "AudioViewer" */
    "./platform-components-assets/AudioViewer-es.js"
  )
), fe = {
  name: "PlayerComponents",
  components: {
    AudioViewer: pe,
    ArticleViewer: q,
    PDFViewer: C,
    ReviewSheet: K,
    InteractiveViewer: te,
    IframeViewer: oe,
    OtherViewer: me,
    ImageDetail: _e
  },
  props: {
    asset: {
      type: Object,
      required: !1
    },
    assetId: {
      type: String,
      required: !1
    },
    template: {
      type: String,
      required: !1
    },
    showTitle: {
      type: Boolean,
      default: !1
    },
    baseURL: {
      type: String,
      required: !1
    },
    windowPaths: {
      type: Object
    },
    codingUrl: {
      type: String
    },
    // custom caption for CIT content
    caption: {
      type: String
    },
    isInline: {
      type: Boolean
    },
    isPreviewModal: {
      type: Boolean,
      required: !1,
      default: !1
    },
    docreaderDomain: {
      type: String,
      default: "docreader-na.readspeaker.com"
    }
  },
  emits: [
    "audio:audioprocess",
    "img-loaded"
  ],
  data() {
    return {
      assetData: null,
      resolvedDocreaderDomain: null
    };
  },
  mounted() {
    this.asset ? (this.assetData = this.asset, this.clicklog()) : f.get(`/player/${this.assetId}`, {
      baseURL: "/learn",
      headers: {
        "X-Requested-with": "XMLHttpRequest"
      }
    }).then((t) => {
      t.data.page_data ? (this.assetData = t.data.page_data.asset, t.data.page_data.docreader_domain && (this.resolvedDocreaderDomain = t.data.page_data.docreader_domain), this.clicklog()) : window.location.href = `/learn/player/${this.assetId}`;
    });
  },
  methods: {
    clicklog() {
      const t = {
        asset_guids: this.assetData.id,
        access_type: 1
      }, i = new FormData();
      Object.keys(t).forEach((e) => i.append(e, t[e])), f.post("/clicklog", i, {
        baseURL: this.baseURL || "/apiproxy/v1",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
    }
  }
};
function we(t, i, e, c, s, r) {
  const l = o("PDFViewer"), _ = o("AudioViewer"), y = o("ArticleViewer"), v = o("ReviewSheet"), b = o("InteractiveViewer"), D = o("IframeViewer"), k = o("ImageDetail"), I = o("OtherViewer");
  return e.template === "pdf" && s.assetData ? (a(), d(l, {
    key: 0,
    asset: s.assetData,
    docreaderDomain: s.resolvedDocreaderDomain || e.docreaderDomain
  }, null, 8, ["asset", "docreaderDomain"])) : e.template === "audio" && s.assetData ? (a(), d(_, {
    key: 1,
    asset: s.assetData,
    id: s.assetData.id,
    showTitle: e.showTitle,
    baseUrl: t.baseUrl,
    "onAudio:audioprocess": i[0] || (i[0] = (P) => t.$emit("audio:audioprocess"))
  }, null, 8, ["asset", "id", "showTitle", "baseUrl"])) : e.template === "article" && s.assetData ? (a(), d(y, {
    key: 2,
    asset: s.assetData
  }, null, 8, ["asset"])) : e.template === "review_sheet" && s.assetData ? (a(), d(v, {
    key: 3,
    asset: s.assetData
  }, null, 8, ["asset"])) : e.template === "embedded_interactive" && s.assetData ? (a(), d(b, {
    key: 4,
    asset: s.assetData,
    windowPaths: e.windowPaths
  }, null, 8, ["asset", "windowPaths"])) : e.template === "iframe" && s.assetData ? (a(), d(D, {
    key: 5,
    asset: s.assetData,
    codingUrl: e.codingUrl,
    isPreviewModal: e.isPreviewModal
  }, null, 8, ["asset", "codingUrl", "isPreviewModal"])) : e.template === "image" && s.assetData ? (a(), d(k, {
    key: 6,
    asset: s.assetData,
    showTitle: e.showTitle,
    isInline: e.isInline,
    caption: e.caption,
    onImgLoaded: i[1] || (i[1] = (P) => t.$emit("img-loaded"))
  }, null, 8, ["asset", "showTitle", "isInline", "caption"])) : e.template === "other" && s.assetData ? (a(), d(I, {
    key: 7,
    asset: s.assetData
  }, null, 8, ["asset"])) : h("", !0);
}
const ke = /* @__PURE__ */ m(fe, [["render", we]]);
export {
  ke as default
};
